import { ErrorWithResourceKey } from '../../shared/errorWithResourceKey';

export class InvalidDataError extends ErrorWithResourceKey {
    constructor() {
        super('InvalidDataError', undefined, 'errors.invalid-data');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/database/invalidDataError.ts